import { LayoutComponent } from "@jelly/lesson";
import config from "appConfig";

const components: LayoutComponent[][] = [
  [
    {
      variant: "layout",
      data: {
        type: "table",
        options: {
          cols: 2,
          rows: 1,
          colsSize: [4, 1],
          components: [
            [
              {
                variant: "blockContainer",
                data: {
                  block: { type: "image", options: { src: `${config.ASSETS_URL}/05/09/principle/flat3m_500.svg` } },
                  styles: { padding: "5%" },
                },
              },
              {
                variant: "blockContainer",
                data: {
                  block: { type: "image", options: { src: `${config.ASSETS_URL}/05/09/principle/scale.svg` } },
                  styles: { padding: "50% 0 20% 0" },
                },
              },
            ],
          ],
        },
      },
    },
  ],
  [
    {
      variant: "layout",
      data: {
        type: "table",
        options: {
          cols: 2,
          rows: 1,
          colsSize: [4, 1],
          components: [
            [
              {
                variant: "blockContainer",
                data: {
                  block: { type: "image", options: { src: `${config.ASSETS_URL}/05/09/principle/flat1m_500.svg` } },
                  styles: { padding: "5%" },
                },
              },
              {
                variant: "blockContainer",
                data: {
                  block: { type: "image", options: { src: `${config.ASSETS_URL}/05/09/principle/scale.svg` } },
                  styles: { padding: "50% 0 20% 0" },
                },
              },
            ],
          ],
        },
      },
    },
  ],
  [
    {
      variant: "layout",
      data: {
        type: "table",
        options: {
          cols: 2,
          rows: 1,
          colsSize: [4, 1],
          components: [
            [
              {
                variant: "blockContainer",
                data: {
                  block: { type: "image", options: { src: `${config.ASSETS_URL}/05/09/principle/convex_500.svg` } },
                  styles: { padding: "5%" },
                },
              },
              {
                variant: "blockContainer",
                data: {
                  block: { type: "image", options: { src: `${config.ASSETS_URL}/05/09/principle/scale.svg` } },
                  styles: { padding: "50% 0 20% 0" },
                },
              },
            ],
          ],
        },
      },
    },
  ],
  [
    {
      variant: "layout",
      data: {
        type: "table",
        options: {
          cols: 2,
          rows: 1,
          colsSize: [4, 1],
          components: [
            [
              {
                variant: "blockContainer",
                data: {
                  block: {
                    type: "image",
                    options: { src: `${config.ASSETS_URL}/05/09/principle/square10cmspaced10cm_500.svg` },
                  },
                  styles: { padding: "5%" },
                },
              },
              {
                variant: "blockContainer",
                data: {
                  block: { type: "image", options: { src: `${config.ASSETS_URL}/05/09/principle/scale.svg` } },
                  styles: { padding: "50% 0 20% 0" },
                },
              },
            ],
          ],
        },
      },
    },
  ],
  [
    {
      variant: "layout",
      data: {
        type: "table",
        options: {
          cols: 2,
          rows: 1,
          colsSize: [4, 1],
          components: [
            [
              {
                variant: "blockContainer",
                data: {
                  block: {
                    type: "image",
                    options: { src: `${config.ASSETS_URL}/05/09/principle/square10cmspaced30cm_500.svg` },
                  },
                  styles: { padding: "5%" },
                },
              },
              {
                variant: "blockContainer",
                data: {
                  block: { type: "image", options: { src: `${config.ASSETS_URL}/05/09/principle/scale.svg` } },
                  styles: { padding: "50% 0 20% 0" },
                },
              },
            ],
          ],
        },
      },
    },
  ],
  [
    {
      variant: "layout",
      data: {
        type: "table",
        options: {
          cols: 2,
          rows: 1,
          colsSize: [4, 1],
          components: [
            [
              {
                variant: "blockContainer",
                data: {
                  block: {
                    type: "image",
                    options: { src: `${config.ASSETS_URL}/05/09/principle/square20cmspaced20cm_500.svg` },
                  },
                  styles: { padding: "5%" },
                },
              },
              {
                variant: "blockContainer",
                data: {
                  block: { type: "image", options: { src: `${config.ASSETS_URL}/05/09/principle/scale.svg` } },
                  styles: { padding: "50% 0 20% 0" },
                },
              },
            ],
          ],
        },
      },
    },
  ],
  [
    {
      variant: "layout",
      data: {
        type: "table",
        options: {
          cols: 2,
          rows: 1,
          colsSize: [4, 1],
          components: [
            [
              {
                variant: "blockContainer",
                data: {
                  block: { type: "image", options: { src: `${config.ASSETS_URL}/05/09/principle/QRD_500.svg` } },
                  styles: { padding: "5%" },
                },
              },
              {
                variant: "blockContainer",
                data: {
                  block: { type: "image", options: { src: `${config.ASSETS_URL}/05/09/principle/scale.svg` } },
                  styles: { padding: "50% 0 20% 0" },
                },
              },
            ],
          ],
        },
      },
    },
  ],
  [
    {
      variant: "layout",
      data: {
        type: "table",
        options: {
          cols: 2,
          rows: 1,
          colsSize: [4, 1],
          components: [
            [
              {
                variant: "blockContainer",
                data: {
                  block: { type: "image", options: { src: `${config.ASSETS_URL}/05/09/principle/random3cm_500.svg` } },
                  styles: { padding: "5%" },
                },
              },
              {
                variant: "blockContainer",
                data: {
                  block: { type: "image", options: { src: `${config.ASSETS_URL}/05/09/principle/scale.svg` } },
                  styles: { padding: "50% 0 20% 0" },
                },
              },
            ],
          ],
        },
      },
    },
  ],
  [
    {
      variant: "layout",
      data: {
        type: "table",
        options: {
          cols: 2,
          rows: 1,
          colsSize: [4, 1],
          components: [
            [
              {
                variant: "blockContainer",
                data: {
                  block: { type: "image", options: { src: `${config.ASSETS_URL}/05/09/principle/random10cm_500.svg` } },
                  styles: { padding: "5%" },
                },
              },
              {
                variant: "blockContainer",
                data: {
                  block: { type: "image", options: { src: `${config.ASSETS_URL}/05/09/principle/scale.svg` } },
                  styles: { padding: "50% 0 20% 0" },
                },
              },
            ],
          ],
        },
      },
    },
  ],
];

export default components;
